'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var setPrototypeOf = require('./setPrototypeOf.js');

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf.default(subClass, superClass);
}

exports.default = _inheritsLoose;
//# sourceMappingURL=inheritsLoose.js.map
